import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-c7e0458c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = {
  class: "course-img"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "course-name text-overflow",
  id: "courseName"
};
const _hoisted_6 = {
  class: "bottom"
};
const _hoisted_7 = {
  class: "course-teacher text-overflow"
};
const _hoisted_8 = {
  class: "course-mes"
};

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 累计选课 ");

const _hoisted_10 = {
  class: "unit"
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 人 ");

const _hoisted_12 = {
  class: "course-mescredit"
};

const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 学分 ");

const _hoisted_14 = {
  class: "num"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "course-line"
}, null, -1));

const _hoisted_16 = {
  class: "course-meshour"
};

const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 学时 ");

const _hoisted_18 = {
  class: "num"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goDetail && $options.goDetail(...args)),
    class: "course-card"
  }, [$props.showResultTag && $props.courseData.results_name ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: "tag-btn",
    style: _normalizeStyle({
      background: $props.resultMap[$props.courseData.results_id]
    })
  }, _toDisplayString($props.courseData.results_name), 5)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: $props.courseData.course_cover_url || require('@/assets/images/common/course_cover.png')
  }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, _toDisplayString($props.courseData.course_name), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createTextVNode(_toDisplayString($props.courseData.lecturer) + " ", 1), _withDirectives(_createElementVNode("span", null, "|", 512), [[_vShow, $props.courseData.lecturer && $props.courseData.organ_name]]), _createTextVNode(" " + _toDisplayString($props.courseData.organ_name), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, [_hoisted_9, _createElementVNode("span", _hoisted_10, _toDisplayString($props.courseData.students_num || 0), 1), _hoisted_11]), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_12, [_hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString($props.courseData.credit || 0), 1)]), _hoisted_15, _createElementVNode("span", _hoisted_16, [_hoisted_17, _createElementVNode("span", _hoisted_18, _toDisplayString($props.courseData.hours || 0), 1)])])])])])]);
}